module.exports = __webpack_public_path__ + "img/Atmos Haus der Musik_1.jpg";